"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSessionManager = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var UrlUtil_1 = require("../../utils/UrlUtil");
var IdleTimer_1 = require("./IdleTimer");
var UserSessionStore_1 = require("./UserSessionStore");
var Servicecommunicator = styled_components_1.default.iframe(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: none;\n"], ["\n\tdisplay: none;\n"])));
Servicecommunicator.displayName = 'Servicecommunicator';
var UserSessionManager = /** @class */ (function (_super) {
    __extends(UserSessionManager, _super);
    function UserSessionManager(props) {
        var _this = _super.call(this, props) || this;
        _this.onIdle = _this.onIdle.bind(_this);
        _this.onAction = _this.onAction.bind(_this);
        var identityServerUrl = new URL(_this.props.identityServerUrl);
        _this.loadComponent = (+UrlUtil_1.UrlUtil.isLocalhost(identityServerUrl) ^ +UrlUtil_1.UrlUtil.isLocalhost(window.location)) === 0;
        _this.identityServerUrl = identityServerUrl.origin;
        _this.lastActiveTimeKey = _this.props.sessionKeyPrefix + '_User_LastActiveTime';
        return _this;
    }
    UserSessionManager.prototype.componentDidMount = function () {
        if (!this.loadComponent) {
            return;
        }
        // This event handler ensures that all open browser tabs refresh (and there by logout)
        // when the user is logged out in any one of the tabs or when the session is expired in one of the tabs
        UserSessionStore_1.UserSessionStore.addSignoutEventHandler(this.props);
        UserSessionStore_1.UserSessionStore.addMessageEventListener(this.props);
        this.onAction();
    };
    UserSessionManager.prototype.render = function () {
        var _this = this;
        return !this.loadComponent ? null : (React.createElement(React.Fragment, null,
            React.createElement(IdleTimer_1.IdleTimer, { ref: function (ref) { return (_this.idleTimer = ref); }, onIdle: this.onIdle, onAction: this.onAction, debounce: 5000, timeout: 60000, events: ['keydown', 'wheel', 'DOMMouseScroll', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown'] }),
            React.createElement(Servicecommunicator, { src: "".concat(this.identityServerUrl, "/home/servicecommunicator"), id: 'servicecommunicator' })));
    };
    UserSessionManager.prototype.onIdle = function () {
        var timeOut = this.props.timeoutInSeconds * 1000;
        var prevTime = localStorage.getItem(this.lastActiveTimeKey);
        if (prevTime && Date.now() - +prevTime >= timeOut) {
            UserSessionStore_1.UserSessionStore.logout(this.props.userManager, this.props.identityServerUrl);
        }
        else {
            if (this.idleTimer) {
                this.idleTimer.reset();
            }
        }
    };
    UserSessionManager.prototype.onAction = function () {
        // we use local storage to be able to sync last active time between multiple open tabs
        localStorage.setItem(this.lastActiveTimeKey, String(Date.now()));
    };
    return UserSessionManager;
}(React.PureComponent));
exports.UserSessionManager = UserSessionManager;
var templateObject_1;
